import { helper } from "lib/helper";
import contact_usModel from "models/contact_us.model";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Table,
  Container,
  Row,
  Input,
  Button,
  UncontrolledTooltip,
} from "reactstrap";
import AddModal from "views/components/AddModal";
// core components
import TablePagination from "views/components/TablePagination";

import { Link } from "react-router-dom";

const TutorsReplaceSummery = () => {
  const [modal, setModal] = useState(false);

  const toggleModal = (modalName) => {
    setModal(!modal);
  };

  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const parameters = {};
  for (let [key, value] of searchParams) {
    parameters[key] = value;
  }

  const getListData = async () => {
    // setIsLoading(true);
    // await contact_usModel
    //   .list(parameters)
    //   .then((result) => {
    //     setIsLoading(false);
    //     if (result) {
    //       setDataList(result);
    //       setCurrentPage(result?.meta?.current_page);
    //       setPerPage(result?.meta?.per_page);
    //     }
    //   })
    //   .catch((error) => {
    //     helper.sweetalert.toast(error.response?.data?.message, "warning");
    //   });
    const dummyData = [
      {
        id: 1,
        tutor_name: "John Tutor",
        class_status: "Completed",
        classes_conducted: 15,
      },
      {
        id: 2,
        tutor_name: "Jane Tutor",
        class_status: "Ongoing",
        classes_conducted: 10,
      },
    ];
    setDataList(dummyData);
    setIsLoading(false);
  };

  useEffect(() => {
    getListData();
  }, [location]);

  const handleDel = async (delId) => {
    helper.sweetalert
      .confirm("Are you sure you want to delete this Message", "info", true)
      .then((result) => {
        if (result.isConfirmed) {
          contact_usModel.delete(delId).then((res) => {
            helper.sweetalert.toast(res.data?.message);
            getListData();
          });
        }
      });
  };

  return (
    <>
      <Container>
        {!isLoading && (
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0 d-flex justify-content-between ">
                  <h3 className="mb-0">Tutors Replace Summary</h3>
                </CardHeader>

                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">SN.</th>

                      <th scope="col">Tutor Name</th>
                      <th scope="col">Class Status</th>
                      <th scope="col">No. Of class Conducated</th>
                      {/* <th scope="col">Download Attendance Summary</th> */}
                    </tr>
                  </thead>

                  <tbody>
                    {dataList?.length > 0 ? (
                      dataList?.map((item, index) => {
                        return (
                          <tr key={item.id}>
                            <td>{index + 1}</td>
                            <td>{item?.tutor_name}</td>
                            <td>{item?.class_status}</td>
                            <td>{item?.classes_conducted}</td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td
                          className="text-center align-middle py-4"
                          colSpan={4}
                        >
                          No data found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
                <CardFooter className="py-4">
                  {/* <TablePagination
                    totalPages={parseInt(dataList?.meta?.total_page)}
                    currentPage={parseInt(dataList?.meta?.current_page)}
                    pageUrl="/admin/messages?"
                  /> */}
                </CardFooter>
              </Card>
            </div>
          </Row>
        )}

        <AddModal
          modal={modal}
          Name="Add6"
          toggle={toggleModal}
          title="Add Fare management"
        />
      </Container>
    </>
  );
};

export default TutorsReplaceSummery;
